import React from 'react';

const JobDescriptionModal = ({ modalId, title, summary, responsibilities, qualifications }) => {
  return (
    <div className="modal fade" id={modalId} data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-hidden="true">
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Job Description</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <h5 className="text-mcolor">Job Summary</h5>
            <p>{summary}</p>

            <h5 className="text-mcolor">Key Responsibilities</h5>
            <ul className="text-secondary text-justify list-group list-group-flush job-desc">
              {responsibilities.map((item, index) => (
                <li key={index} className="list-group-item">
                  <i className="bi bi-cpu-fill"></i>
                  <p>{item}</p>
                </li>
              ))}
            </ul>

            {qualifications && qualifications.length>0 && <h5 className="text-mcolor">Required Qualifications</h5>}
            <ul className="text-secondary text-justify list-group list-group-flush job-desc">
              {qualifications.map((item, index) => (
                <li key={index} className="list-group-item">
                  <i className="bi bi-cpu-fill"></i>
                  <p>{item}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobDescriptionModal;
